/** Public surface of the i18n module — import from `@/i18n` rather than
 *  reaching into `./locales`, `./detect`, etc. */

export {
  SUPPORTED_LOCALES,
  PLANNED_LOCALES,
  DEFAULT_LOCALE,
  LOCALE_LABEL,
  isSupportedLocale,
  coerceLocale,
  type SupportedLocale,
  type PlannedLocale,
} from "./config";

export { translate, makeTranslator, formatTimeAgo, type T, type TranslateParams } from "./translate";
export { LocaleProvider, useLocale, useT } from "./provider";
export {
  resolveClientLocale,
  readStoredLocale,
  writeStoredLocale,
  readQueryLocale,
  readBrowserLocale,
  LOCALE_STORAGE_KEY,
} from "./detect";
export { resolveServerLocale, parseAcceptLanguage } from "./server";
